var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 12.0028H4.43865C2.72398 12.0001 1.33398 10.6621 1.33398 9.01142C1.33398 7.36142 2.72398 6.02342 4.43865 6.02342C4.70065 4.84875 5.63465 3.89009 6.88865 3.50809C8.14198 3.12675 9.52598 3.37942 10.518 4.17475C11.51 4.96809 11.9593 6.17942 11.698 7.35409H12.358C13.278 7.35409 14.0733 7.89609 14.4447 8.68075M12.6673 10.6668V14.6668M12.6673 14.6668L14.6673 12.6668M12.6673 14.6668L10.6673 12.6668",
    stroke: "#00332D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloud);
export default __webpack_public_path__ + "static/media/downloadCloud.2187c2337e230275fe3669542a13f84f.svg";
export { ForwardRef as ReactComponent };